import { useEffect, useState } from "react";

export function useAccuCustomization() {
    const [accuCustomization, setAccCustomization] = useState(globalThis.accuCustomization);
    const setAccu = () => {
        setAccCustomization(globalThis.accuCustomization);
    };

    useEffect(() => {
        document.addEventListener("accu:updated", setAccu);
        return () => document.removeEventListener("accu:updated", setAccu);
    }, []);

    return accuCustomization;
}
